import { useTranslation } from "react-i18next";

export function CancelReasonStep({ onSelectReason }) {
    const { t } = useTranslation();

    const reasons = [
        { id: "not_using", label: t("billing.supportPlans.cancel.notUsing"), icon: "⏸️", solution: "pause" },
        { id: "too_expensive", label: t("billing.supportPlans.cancel.tooExpensive"), icon: "💰", solution: "support" },
        { id: "project_over", label: t("billing.supportPlans.cancel.projectComplete"), icon: "✅", solution: "confirm" },
        { id: "missing_features", label: t("billing.supportPlans.cancel.missingFeatures"), icon: "🔧", solution: "support" },
        { id: "using_another", label: t("billing.supportPlans.cancel.usingAnother"), icon: "🔄", solution: "confirm" },
        { id: "technical_issues", label: t("billing.supportPlans.cancel.technicalIssues"), icon: "🐛", solution: "support" },
    ];

    return (
        <div className="space-y-4">
            <p className="text-muted-foreground mb-6">
                {t("billing.supportPlans.cancel.helpUsImprove")}
            </p>
            <div className="grid gap-3">
                {reasons.map((reason) => (
                    <button
                        key={reason.id}
                        onClick={() => onSelectReason(reason)}
                        className="flex items-center gap-4 p-4 border-2 border-border rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all text-left"
                    >
                        <span className="text-2xl">{reason.icon}</span>
                        <span className="font-medium">{reason.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
